import { SelectOption } from '@leasequery/lq.react-component-library';
import { RuleBuilderInput, RuleBuilderInputValue } from '../..';

const fillMissingLabelForDropdownInputValues = (
  value: RuleBuilderInputValue,
  dropdownFieldValues: Map<number, SelectOption<number>>,
): {
  isUpdated: boolean;
  nextValue: RuleBuilderInputValue;
} =>
  !value
    ? { isUpdated: false, nextValue: value }
    : (value as SelectOption<number>[]).reduce(
        (acc, opt) => {
          const dropdownOption = dropdownFieldValues.get(opt.value);
          const label = dropdownOption?.label || opt.label;
          acc.isUpdated = acc.isUpdated || label !== opt.label;
          acc.nextValue.push({ ...opt, label });

          return acc;
        },
        {
          isUpdated: false as boolean,
          nextValue: [] as SelectOption<number>[],
        },
      );

const fillMissingLabelForDropdownInput = (
  rule: RuleBuilderInput,
  dropdownFieldValues: Map<number, SelectOption<number>>,
): {
  isUpdated: boolean;
  rule: RuleBuilderInput;
} => {
  const {
    isUpdated: isValue1Updated,
    nextValue: nextValue1,
  } = fillMissingLabelForDropdownInputValues(rule.value1, dropdownFieldValues);

  const {
    isUpdated: isValue2Updated,
    nextValue: nextValue2,
  } = fillMissingLabelForDropdownInputValues(rule.value2, dropdownFieldValues);

  if (isValue1Updated || isValue2Updated) {
    return {
      isUpdated: true,
      rule: { ...rule, value1: nextValue1, value2: nextValue2 },
    };
  }
  return { isUpdated: false, rule };
};

export { fillMissingLabelForDropdownInput };
